import React from "react";

import Addposter from "../../assets/images/Home/Choosesec/addposter.png";
import { Col, Row } from "react-bootstrap";
const Choosekansensus = () => {
  return (
    <>
      <div className="choose-kansensus-component container" id="about-us">
        <Row>
          <Col className="choose-kansensus-details pt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              <h5>Why Choose Bizooka</h5>
              <h1>
                connecting customers <span>to businesses</span>
              </h1>
              <div className="para mt-3">
                <p>
                  Bizooka was designed by business owners for business owners.
                  We have an understanding of the frustrations that come with
                  having a business profile on social media. Being scrolled past
                  because users are there for entertainment, while also having
                  to stay on top of trends and latest hooks, in hope that you
                  grab someone's attention. Well not any more!
                </p>
                <br />
                <p>
                  On Bizooka, you let your authentic business content do the
                  talking, as our users are on the platform with intentions of
                  finding the perfect services or product for their needs. With
                  no social posts or social interactions between users, this
                  makes Bizooka strictly business.
                </p>
              </div>
            </div>
          </Col>
          <Col
            className="choose-kansensus-image mt-5"
            xs={12}
            md={12}
            lg={{ span: 4, offset: 2 }}
          >
            <img src={Addposter} alt="" />
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Choosekansensus };
